import {ISystem} from "../../../index";
import infoHtml from './info.html?raw';

export const template = infoHtml;

interface IParams {
    d: ISystem
}

export class viewModel {
    private readonly d: ISystem;

    constructor(params: IParams) {
        this.d = params.d
    }
}
